import { ReactElement, useRef, useEffect } from 'react';

export default function JotForm({
  formId,
  title,
}: {
  formId: string;
  title: string;
}): ReactElement {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const handleIFrameMessage = (e: MessageEvent): void => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    if (typeof e.data !== 'string') {
      return;
    }

    const args = e.data.split(':');
    switch (args[0]) {
      case 'scrollIntoView':
        iframe.scrollIntoView();
        break;
      case 'setHeight':
        iframe.style.height = args[1] + 'px';
        break;
      case 'collapseErrorPage':
        if (iframe.clientHeight > window.innerHeight) {
          iframe.style.height = window.innerHeight + 'px';
        }
        break;
      case 'reloadPage':
        window.location.reload();
        break;
    }
    const isJotForm = e.origin.indexOf('jotform') > -1 ? true : false;
    const contentWindow = iframe.contentWindow as Window;
    if (isJotForm && 'contentWindow' in iframe && 'postMessage' in contentWindow) {
      const urls = {
        docurl: encodeURIComponent(document.URL),
        referrer: encodeURIComponent(document.referrer),
      };
      contentWindow.postMessage(JSON.stringify({ type: 'urls', value: urls }), '*');
    }
  };

  useEffect(() => {
    if (window.addEventListener) {
      window.addEventListener('message', handleIFrameMessage, false);
    }

    const iframe = iframeRef.current;
    if (iframe) {
      let src = iframe.src;
      let iframeParams: string[] = [];
      if (window.location.href && window.location.href.indexOf('?') > -1) {
        iframeParams = iframeParams.concat(
          window.location.href.substr(window.location.href.indexOf('?') + 1).split('&')
        );
      }
      if (src && src.indexOf('?') > -1) {
        iframeParams = iframeParams.concat(src.substr(src.indexOf('?') + 1).split('&'));
        src = src.substr(0, src.indexOf('?'));
      }
      iframeParams.push('isIframeEmbed=1');
      iframe.src = src + '?' + iframeParams.join('&');
    }
    return () => {
      window.removeEventListener('message', handleIFrameMessage);
    };
  }, []);

  return (
    <>
      <iframe
        id={`JotFormIFrame-${formId}`}
        title={title}
        ref={iframeRef}
        // onLoad="window.parent.scrollTo(0,0)"
        allowFullScreen={true}
        allow="geolocation; microphone; camera"
        src={`https://form.jotform.com//${formId}`}
        frameBorder="0"
        style={{
          minWidth: '100%',
          height: '539px',
          border: 'none',
        }}
        scrolling="no"
      ></iframe>
    </>
  );
}
